/**
 * Exchanges filter utilities.
 * Filters PBH API responses to exchange requests only.
 */

/**
 * Filters PBH API response to only exchange requests.
 * Exchange requests have ExchangeRequestId (or camelCase exchangeRequestId);
 * repairs use Id/RepairRequestId.
 *
 * If no items match, returns all orders so the list is not empty
 * (backend may not set ExchangeRequestId on list response).
 *
 * @param orders - Raw orders from PBH API
 * @returns Filtered exchange orders
 */
export function resolveExchangeRequestId(
  row: unknown,
): number | string | null {
  if (!row || typeof row !== "object") {
    return null;
  }
  const record = row as Record<string, unknown>;
  const id = record.ExchangeRequestId ?? record.exchangeRequestId;
  if (id == null || id === "") {
    return null;
  }
  return typeof id === "number" || typeof id === "string" ? id : null;
}

export function filterExchangeOrders<T extends Record<string, unknown>>(
  orders: T[],
): T[] {
  const withExchangeId = orders.filter(
    (o) =>
      (o as Record<string, unknown>).ExchangeRequestId != null ||
      (o as Record<string, unknown>).exchangeRequestId != null,
  );
  if (withExchangeId.length > 0) return withExchangeId;
  return orders;
}
